import React, { Component } from 'react';
import Draggable from 'react-draggable';
export default class ScreensaverInfo extends Component {

  render () {
    const {
      hideInfoDialog
    } = this.props;

    return (
      <Draggable bounds='parent' handle=".screensaver-dialog-header">
        <div className="screensaver-settings-info-dialog">
          <div className="screensaver-dialog-header">
            About this website
            <div className="screensaver-dialog-header-action screensaver-dialog-close"
               onClick={hideInfoDialog}>
              &times;
            </div>
          </div>
          <div className="screensaver-dialog-body">
            <div className="screensaver-info-container">
              <p>
                Thanks for visiting our website. The screensaver was written with&nbsp;
                <a href="https://threejs.org" target="_blank">ThreeJS</a> and&nbsp;
                <a href="https://github.com/tweenjs/tween.js/" target="_blank">TweenJS</a>. We're working hard to make it as authentic as possible.
              </p>
              <p>
                This website was made by the team at&nbsp;
                <a href="https://www.mixfont.com" target="_blank">Mixfont</a>, the modern font generator. Try Mixfont for creating font pairings for your next project!
              </p>
            </div>
            <div className="screensaver-info-button-container">
              <div className="screensaver-dialog-button"
                onClick={hideInfoDialog}>
                Close
              </div>
            </div>
          </div>
        </div>
      </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/projects/screensaver/ScreensaverInfo.jsx